import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axios } from 'Lib/axios'

import { useUserStore } from 'Stores/userStoreModuleFed'

type Params = {
  type: string
  value: string | number
}

const updateData = async (params: Params) => {
  const userId = useUserStore.getState().userId
  const payload = {}
  if (params) {
    payload[params.type] = params.value
  }
  await axios.put(`users/${userId}/profile`, payload)
}

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient()
  return useMutation(updateData, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['userProfile'])
    },
  })
}
